<template>
  <div class="IncreaseProductCategory">
    <el-dialog
      title="添加物品类目"
      :visible.sync="dialogVisible"
      width="50%"
      :before-close="beforeCloseComponents"
    >
      <el-form
        class="custom-formItem"
        ref="formData"
        label-width="100px"
        inline
        :model="formData"
        :rules="rulesFormData"
      >
        <el-form-item label="物品类目" prop="categoryName">
          <el-input v-model="formData.categoryName" placeholder="请输入物品类目"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" @click="handleIncrease" :loading="loadingIncrease">添加</el-button>
        </el-form-item>
      </el-form>

      <el-table :data="listTable" border size="small">
        <el-table-column prop="categoryName" align="center" label="物品类目"></el-table-column>
        <el-table-column align="center" label="操作">
          <template slot-scope="scope">
            <el-button type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'

export default {
  name: 'IncreaseProductCategory',
  data() {
    return {
      dialogVisible: false,
      formData: {
        categoryName: ''
      },
      rulesFormData: {
        categoryName: [
          { required: true, message: '请输入物品类目', trigger: 'blur' }
        ]
      },
      listTable: [],
      loadingIncrease: false
    }
  },
  methods: {
    initComponents() {
      this.dialogVisible = true

      this.getListTable()
    },
    beforeCloseComponents(done) {
      this.loadingIncrease = false
      this.$refs.formData.resetFields()
      this.$refs.formData.clearValidate()
      done()
    },
    handleIncrease() {
      this.$refs.formData.validate((valid) => {
        if (!valid) return
        const API = Baseurl + 'logisticsConfigurationController/insertLogisticsCategory'
        const paramsData = this.formData
        this.loadingIncrease = true

        ajaxPost(API, paramsData).then(res => {
          const { code } = res.data
          this.loadingIncrease = false
          if (code === 200) {
            this.$refs.formData.resetFields()
            this.$message.success('操作成功！')
            this.getListTable()
          }
        })
      })
    },
    handleDelete(row) {
      this.$confirm('确定要删除该物品类目数据吗？', '提示')
        .then(() => {
          const API = Baseurl + 'logisticsConfigurationController/deleteLogisticsCategory'
          const paramsData = {
            id: row.id
          }

          ajaxPost(API, paramsData).then(res => {
            const { code, data } = res.data
            if (code === 200) {
              this.$message.success('操作成功！')
              this.getListTable()
            } else if (code === 500) {
              this.$message.error(data)
            } else {
              this.$message.error('操作失败！')
            }
          })
        })
    },
    getListTable() {
      const API = Baseurl + 'logisticsConfigurationController/selectLogisticsCategoryList'

      ajaxPost(API).then(res => {
        const { code, data } = res.data
        if (code === 200) {
          this.listTable = data
        }
      })
    }
  }
}
</script>
